<ng-container *abcLet="res$ | async as res">
  <div class="containerWaterFilling resource_event_border">
    <div class="detailContainerWaterFilling">
      <div fxLayout="row" class="icon-container">
        <mat-icon
          class="iconHeaderWaterFilling"
          [svgIcon]="res.svgName(this.resourcesNavigationContext.resourceEventGroup.resourceEventTypeGroup.iconName)"
        ></mat-icon>
        <span class="resource_event_boldLabel">{{
          this.resourcesNavigationContext.resourceEventGroup.resource.name
        }}</span>
      </div>
      <resource-navigation></resource-navigation>
      <div fxLayout="row" fxLayout.xs="column" fxLayoutWrap fxLayoutGap="16px" class="startContainer">
        <div class="dateHolder">
          <abc-date-box
            (onValueChanged)="safeSetValue($event, 'date')"
            [disabled]="this.isDisabled"
            [labelMode]="'floating'"
            [label]="res.get('Resources-ResourceEvent-Date')"
            [showClearButton]="true"
            [stylingMode]="'filled'"
            [type]="'date'"
            [useMaskBehavior]="true"
            [value]="this.resourceEvent?.date"
            [ngStyle]="{ width: '230px' }"
            [ngStyle.xs]="{ width: '380px' }"
            valueChangeEvent="keyup"
          >
          </abc-date-box>
        </div>
        <div class="timeHolder">
          <abc-date-box
            (onValueChanged)="safeSetValue($event, 'time')"
            [disabled]="this.isDisabled"
            [labelMode]="'floating'"
            [label]="res.get('Resources-ResourceEvent-Time')"
            [showClearButton]="true"
            [stylingMode]="'filled'"
            [type]="'time'"
            [useMaskBehavior]="true"
            [value]="this.resourceEvent?.time"
            [ngStyle]="{ width: '230px' }"
            [ngStyle.xs]="{ width: '380px' }"
            valueChangeEvent="keyup"
          >
          </abc-date-box>
        </div>
      </div>
      <div fxLayout="row" fxLayout.xs="column" fxLayoutWrap fxLayoutGap="16px" class="endContainer">
        <div class="timeHolder">
          <abc-drop-down-box
            #dropDownStation
            (onValueChanged)="safeSetValue($event, 'idRefResourceEventType')"
            [disabled]="this.isDisabled"
            [labelMode]="'floating'"
            [label]="res.get('Resources-ResourceEventVehicleWaterFilling-Station')"
            [stylingMode]="'filled'"
            [validationStatus]="'valid'"
            [value]="this.resourceEvent?.idRefResourceEventType"
            [ngStyle]="{ width: '476px' }"
            [ngStyle.xs]="{ width: '380px' }"
          >
          </abc-drop-down-box>
        </div>
        <div class="quantityHolder">
          <abc-number-box
            (onValueChanged)="safeSetValue($event, 'resultValue')"
            [disabled]="this.isDisabled"
            [labelMode]="'floating'"
            [label]="res.get('Resources-ResourceEventVehicleWaterFilling-WaterQuantity')"
            [showClearButton]="true"
            [stylingMode]="'filled'"
            [value]="this.resourceEvent?.resultValue"
            [ngStyle]="{ width: '160px' }"
            [ngStyle.xs]="{ width: '380px' }"
            [format]="this.resourceEvent?.valueFormat"
            valueChangeEvent="keyup"
          >
          </abc-number-box>
        </div>
      </div>
      <div fxLayout="row" fxLayout.xs="column">
        <div>
          <abc-text-area
            (onValueChanged)="safeSetValue($event, 'comment')"
            [disabled]="this.isDisabled"
            [height]="'90px'"
            [labelMode]="'floating'"
            [label]="res.get('Resources-ResourceEventVehicleWaterFilling-Description')"
            [stylingMode]="'filled'"
            [value]="this.resourceEvent?.comment"
            [ngStyle]="{ width: '652px' }"
            [ngStyle.xs]="{ width: '380px' }"
            valueChangeEvent="keyup"
          >
          </abc-text-area>
        </div>
      </div>
    </div>
  </div>
</ng-container>
